import { formatNum, formatPercentNum, getUpAndDownStatus } from "@/pages/dashboard/utils/utils";
import moment from "moment";

// 表格返回数据格式整理
export function fomaterVersionData(tableData: any, metricsInfo: any, timeType = "Day") {
  if (!Array.isArray(tableData)) return []
  return tableData.map((data) => {
    const { metrics, type, ...accumulates } = data || {};
    const date = data?.dimensions?.date || ''
    // 指标列数据
    Object.keys(metricsInfo).forEach(key => {
      // if (!metricsInfo[key]) return; // 后端会返回全量指标的数据, 而前端页面可能只展示部分指标
      const { value, dod, sdlw } = metrics[key] || { value: "", dod: "", sdlw: "" }
      const { isPercent, decimals, isUserType, dodDecimals } = metricsInfo[key] // TODO 如果指标信息的配置对象格式不同, 导致逻辑无法复用
      const progressWidth = isPercent ? value * 100 : 0; // 单元格内进度条的宽度
      const metricValue = isPercent ? formatPercentNum(value, decimals, false) : formatNum(value, false, isUserType);
      const dodStatus = getUpAndDownStatus(dod, false);
      const sdlwStatus = getUpAndDownStatus(sdlw, false);
      const dodPercentStr = formatPercentNum(dod, dodDecimals, true)
      const sdlwPercentStr = formatPercentNum(sdlw, dodDecimals, true)

      metrics[key] = {
        progressWidth: progressWidth > 100 ? 100 : progressWidth,
        metricValue,
        dodStatus,
        sdlwStatus,
        dodPercentStr,
        sdlwPercentStr,
        ...metrics[key]
      }
    })

    return {
      date: date,
      // 周六或者周日 表格行高亮
      isSatOrSun: timeType === "Day" && (moment(date).format('E') === '6' || moment(date).format('E') === '7'),
      metrics,
      ...accumulates
    }
  })

}